/* @flow */

import { getEnv } from 'tve/helpers/env'

const apiHost = getEnv('API_HOST') ?? '/'
const consulting = `/api/consulting`
const leads = `${consulting}/leads`

export const requestUrls = (apiHost) => {
  return {
    apiCreateLead: `${apiHost}${leads}`,
    apiCreateCallback: `${apiHost}${consulting}/callbacks`,
    apiGetLead: `${apiHost}${leads}/\${id}`,
    apiPushLead: `${apiHost}${leads}/\${id}`,
    apiCancelLead: `${apiHost}${leads}/\${id}/cancel`,
    apiOtpGenerate: `${apiHost}${leads}/\${id}/otp/generate`,
    apiOtpVerify: `${apiHost}${leads}/\${id}/otp/verify`,
    apiGetBranch: `${apiHost}${consulting}/branches`,
    apiGetTopics: `${apiHost}${consulting}/topics`,
    apiGetAppointmentSlots: `${apiHost}${consulting}/slots?\${params}`,
    apiUpdateAppointmentSlots: `${apiHost}${leads}/\${id}/slots?start_date=\${startDate}`,
    apiLeadDocuments: `${apiHost}${leads}/\${lead_id}/documents`,
    apiLeadDocumentDelete: `${apiHost}${leads}/\${lead_id}/documents/\${docId}`,
    apiClient: `${apiHost}${consulting}/clients/\${identifier}`,
    apiAdvisorByEmail: `${apiHost}${consulting}/advisors/\${email}`
  }
}

export const cybwellToken = `${apiHost}/api/address_token`
export const cybwellAddressSuggest =
  'https://webservice.cybwell.ch/onboarding/suggestadress.ashx?style=JSON&q=${query}&callback=dog&SOURCE=CYB-A-ENGINE&token=${token}'
export const cybwellAddressDetail =
  'https://webservice.cybwell.ch/onboarding/getAdressDetail.ashx?style=JSON&legacyid=${legacyId}&callback=dog&token=${token}'
